"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const nostore = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-nostore` : '') + (description ? ` desc-nostore` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-nostore"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-nostore"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.266 22.5H21.25c.69 0 1.25-.56 1.25-1.25V5.06L21 6.493V16h-3.5v-3.5h.495c.895 0 1.5-.914 1.15-1.738l-.752-1.774-1.16 1.109.384.903H16.29l-1.568 1.5H16V21h-3.5v-6.376L11 16.06V21H7.5v-1.593L6 20.842V21h-.165l-1.569 1.5Zm-1.282-5H2.5v.462L1 19.397V2.5H.75a.75.75 0 0 1 0-1.5h19.483l-1.568 1.5H2.5V16h2.052l-1.568 1.5ZM6 14.615l1.5-1.435v-.68h.71L9.78 11H5.883l1.909-4.5h6.691l1.557-1.489A1.252 1.252 0 0 0 15.874 5H7.626c-.501 0-.954.3-1.15.762l-2.121 5a1.25 1.25 0 0 0 1.15 1.738H6v2.115ZM17.5 21v-3.5H21V21h-3.5ZM.208 23.268a.75.75 0 0 1 .024-1.06l23-22a.75.75 0 1 1 1.036 1.084l-23 22a.75.75 0 0 1-1.06-.024Z",
    fill: "inherit"
  }));
};
var _default = exports.default = nostore;